<template>
  <Form
    v-slot="{ handleSubmit }"
    :validation-schema="validationSchema"
    @submit="sendQuestion"
  >
    <Modal
      :show="show"
      :title="$t('ui.faq.ask_question.title')"
      icon="Help"
      :loading="loading"
      :error-message="errorMessage"
      :confirm="($event) => handleSubmit($event, sendQuestion)"
      :confirm-text="$t('ui.faq.ask_question.send_question')"
      size="md"
      @close="$emit('close')"
    >
      <p class="mb-4 text-secondary">
        {{ $t('ui.faq.ask_question.description') }}
      </p>

      <TextArea
        v-model="question"
        :label="$t('ui.faq.ask_question.question_label')"
        :placeholder="$t('ui.faq.ask_question.question_placeholder')"
        name="question"
        required
        :rows="8"
      />
    </Modal>
  </Form>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { object, string } from 'yup'
import { Form } from 'vee-validate'
import { useI18n } from 'vue-i18n'

import Modal from '@/components/misc/Modal'
import TextArea from '@/components/controls/TextArea'

import { useEventBus } from '@/composables/event_bus'
import { SystemService } from '@/services/system/system'
import { retrieveErrorsMessages } from '@/helpers/errors'

defineProps<{
  show?: boolean
}>()

const emit = defineEmits<{
  close: []
}>()

const { t } = useI18n()
const eventBus = useEventBus()

const validationSchema = object({
  question: string().required().min(10).max(2048),
})

const errorMessage = ref<string[]>([])
const loading = ref(false)
const question = ref('')

async function sendQuestion() {
  loading.value = true
  errorMessage.value = []

  try {
    await SystemService.postFAQQuestion(question.value.trim())

    eventBus.emit('success', {
      message: t('messages.faq.success_submit'),
    })

    emit('close')
    question.value = ''
  } catch (err: any) {
    if (err.response?.status === 429) {
      errorMessage.value = [
        t('messages.faq.ask_limit', {
          limit: err.response.data.detail,
        }),
      ]
    } else {
      errorMessage.value = retrieveErrorsMessages(err)
    }
  } finally {
    loading.value = false
  }
}
</script>
